// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.food_tasting_image_theme */
var FoodTastingImageTheme;
(function (FoodTastingImageTheme) {
    FoodTastingImageTheme["dark"] = "dark";
    FoodTastingImageTheme["light"] = "light";
})(FoodTastingImageTheme || (FoodTastingImageTheme = {}));
;
export default FoodTastingImageTheme;
/** Zod schema for food_tasting_image_theme */
export const foodTastingImageTheme = z.nativeEnum(FoodTastingImageTheme);
//# sourceMappingURL=FoodTastingImageTheme.js.map